"use client";

import { useQuery } from "@tanstack/react-query";
import type { MindstringPrototype } from "@/generated/fastapi";
import { useAuth } from "@/state/globalStore";
import { getCriteria } from "../api/getCriteria";
import { criteriaKeys } from "./keys";

interface UseCriteriaQueryProps {
  targetId?: string | null;
  prototypeCategory?: MindstringPrototype | null;
}

export default function useCriteriaQuery({
  targetId,
  prototypeCategory,
}: UseCriteriaQueryProps) {
  const { accessToken } = useAuth();
  const queryKey = targetId
    ? criteriaKeys.list({
        targetId,
        prototypeCategory: prototypeCategory ?? undefined,
      })
    : criteriaKeys.all;

  return useQuery({
    queryKey,
    queryFn: async () => {
      if (!targetId) {
        return [];
      }

      return getCriteria(accessToken, {
        target_ids: [targetId],
        prototype: prototypeCategory,
      });
    },
    enabled: Boolean(accessToken && targetId),
    staleTime: 1000 * 60 * 5,
  });
}
